import React, { useState, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { Modal } from "react-bootstrap";
import { useAppSelector } from "../../hooks";
import { RootState } from "../../../redux/store";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";


type Props = {
  id:string
}
export function ProductEditDialogHeader(props:Props) {
  // Products Redux state
  const { productForEdit, actionsLoading } = useAppSelector((state: RootState) => state.products, shallowEqual)
  const [title, setTitle] = useState("");
  // Title couting
  useEffect(() => {
    let _title = props.id ? "" : "New Article";
    if (productForEdit && props.id) {
      _title = `Edit article '${productForEdit.id} ${productForEdit.desc}'`;
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [productForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
